import BaseComponent from 'foundation/base-component';
import eventBus from 'general/js/event-bus';

const SUBLAYOUT_FULLWIDTH_ENABLE = 'SUBLAYOUT_FULLWIDTH_ENABLE';
const SUBLAYOUT_FULLWIDTH_DISABLE = 'SUBLAYOUT_FULLWIDTH_DISABLE';

class SublayoutComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        eventBus.addListener(SUBLAYOUT_FULLWIDTH_ENABLE, this.enableFullwidth);
        eventBus.addListener(SUBLAYOUT_FULLWIDTH_DISABLE, this.disableFullwidth);
    }

    onDestroy() {
        eventBus.removeListener(SUBLAYOUT_FULLWIDTH_ENABLE, this.enableFullwidth);
        eventBus.removeListener(SUBLAYOUT_FULLWIDTH_DISABLE, this.disableFullwidth);
    }

    enableFullwidth = () => {
        this.element.classList.add('is-fullwidth');
    }

    disableFullwidth = () => {
        this.element.classList.remove('is-fullwidth');
    }
}

export default SublayoutComponent;
